export default __webpack_public_path__ + "static/media/phone.33350558.svg";